const authInitialState = {
  auth: {
    loading: false,
    error: null,
    data: null,
  },
  authTraza: {
    loading: false,
    error: null,
    data: null,
  },
};

export default authInitialState;
